// src/assets/icons/index.js
// 批量导入目录下所有 .svg 后缀的文件
const req = require.context('./', false, /\.svg$/);
req.keys().forEach(req);